import React from 'react';
import './SuggestionBubbles.css';

function SuggestionBubbles({ onSuggestionClick }) {
  const suggestions = [
    {
      id: 1,
      text: "How can I make my daily walks more mindful?",
      category: "wellness"
    },
    {
      id: 2,
      text: "Building confidence through sports mindset",
      category: "personal-growth"
    },
    {
      id: 3,
      text: "Balancing my passion for cars with personal growth",
      category: "interests"
    },
    {
      id: 4,
      text: "Tips for maintaining healthy daily routines",
      category: "habits"
    },
    {
      id: 5,
      text: "Using competitive drive for self-improvement",
      category: "motivation"
    },
    {
      id: 6,
      text: "How to stay focused on personal goals",
      category: "goals"
    },
    {
      id: 7,
      text: "Connecting sports discipline with daily life",
      category: "lifestyle"
    },
    {
      id: 8,
      text: "Managing stress through physical activity",
      category: "wellness"
    }
  ];

  // Group suggestions by category for better organization
  const categories = {
    wellness: "#4CAF50",     // Green
    "personal-growth": "#2196F3", // Blue
    interests: "#FF9800",    // Orange
    habits: "#9C27B0",      // Purple
    motivation: "#F44336",   // Red
    goals: "#00BCD4",       // Cyan
    lifestyle: "#795548"     // Brown
  };

  return (
    <div className="suggestion-container">
      <div className="suggestion-title">What's on your mind?</div>
      <div className="suggestion-scroll">
        {suggestions.map(suggestion => (
          <button
            key={suggestion.id}
            className={`suggestion-bubble ${suggestion.category}`}
            onClick={() => onSuggestionClick(suggestion.text)}
            style={{
              backgroundColor: categories[suggestion.category] + '15', // Light version of the color
              borderColor: categories[suggestion.category],
              color: categories[suggestion.category]
            }}
          >
            {suggestion.text}
          </button>
        ))}
      </div>
    </div>
  );
}

export default SuggestionBubbles; 